import {Avatar, Menu} from "@mantine/core";
import {useContext} from "react";
import AuthContext from "../../../contexts/auth/AuthContext";
import {IconDoorExit} from "@tabler/icons-react";
import Notifications from "../../../utils/notifications/Notifications";
import {useNavigate} from "react-router-dom";

/**
 * Displays the first user's letter as avatar.
 * Actually does not allow logging out.
 * @author Kacper Faber
 * @since 0.1.1
 * @constructor
 */
function CurrentUser() {
    /**
     * auth context
     * @author Kacper Faber
     * @since 0.1.1
     */
    const authContext = useContext(AuthContext);
    const nav = useNavigate();

    /**
     * Returns first letter of user username.
     * Username comes from the auth context.
     * @author Kacper Faber
     * @since 0.1.1
     */
    const getInitials = () => {
        return authContext?.user?.username?.at(1)?.toUpperCase();
    }

  const onLogout = () => {
    authContext.logout()
      .then(() => { Notifications.onLogoutSuccess(); })
      .then(() => { nav("/login"); });
  }

    return (
      <Menu shadow="md">
        <Menu.Target>
          <Avatar size="md" color="primary.4" variant="filled" styles={{ root: { cursor: "pointer" } }}>
            { getInitials() }
          </Avatar>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item color="red" leftSection={<IconDoorExit size={14} />} onClick={onLogout}>
            Wyloguj się
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    );
}

export default CurrentUser;

// TODO: CurrentUser.tsx
//  - Add logout button
//  - Add user menu